'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = context;


/**
 * Get the context, be it window or global
 * @returns {boolean|Window|*|context}
 */
function context() {
  return typeof window !== 'undefined' && window || typeof global !== 'undefined' && global || this;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-on-rails/node_package/lib/context.js
// module id = 398
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14